// Shamelessly stolen from https://levelup.gitconnected.com/react-utility-components-building-4-react-components-that-improve-any-app-2fa0e4672e0f
// This component conditionally renders its children based on the provided {condition} prop. It can
// render the optional {otherwise} prop if the condition fails.
// Use this in place of ugly looking things like `{someCondition ? <Component> : null}`
// For example:
//
// Bad:
//     render(){
//       let bazBar = null;
//       if(props.foobar === "baz"){
//         bazBar = <BazBar/>
//       }else{
//         bazBar = "No BazBar for you!";
//       }
//       return (
//         <div>
//           <input/>
//           {bazBar}
//         </div>
//         )
//     }
//
// Good:
//    render(){
//      return (
//        <div>
//          <input/>
//          <If condition={props.foobar === "baz"} otherwise={"No BazBar for you!"}>
//            <BazBar/>
//          </if>
//        </div>
//      )
//    }

import PropTypes from "prop-types";

function If(props) {
  return props.condition ? props.children : props.otherwise;
}

If.propsTypes = {
  condition: PropTypes.bool,
  otherwise: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

If.defaultProps = {
  otherwise: null
};

export default If;
